import produce from 'immer';

const feedItemKey = (activity) =>
  activity?.actionId ||
  (activity?.type === 'REPLY' && activity?.replyId
    ? `REPLY:${activity.replyId}`
    : activity?.commentId
      ? `COMMENT:${activity.commentId}`
      : null);

const dedupeByActionId = (activities) => {
  const seen = new Set();
  return activities.filter((activity) => {
    const key = feedItemKey(activity);
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const reducer = (state = { loading: false, entityStrings: [], activities: [], hasMore: false, loadedTime: null, nextCursor: null }, action) => produce(state, draftState => {
	const alignCommentActivity = activity =>{
		if(activity.type !== 'COMMENT') return activity;
		const commentId = activity.action._id
		const content = activity.content[0];
		const commonComment = content.comments.find(comment => comment._id === commentId);
		if(!commonComment) return activity;
	    const newComments = [
	    	commonComment,
          	...content.comments.filter(item => item._id !== commonComment._id),
        ];
        content.comments = newComments;
		return activity;
	}
	switch (action.type){
		case 'SET_NEWSFEED': {
			draftState.loading = true;
			break;
		}

		case 'SET_NEWSFEED_$':{
	      	let { activities, loadedTime, hasMore, nextCursor } = action.json;
	        activities = dedupeByActionId(activities || []).map(activity => {
      			return alignCommentActivity(activity)
	        })
		    draftState.loading = false;
		    draftState.activities = activities;
		    draftState.hasMore = Boolean(hasMore);
		    draftState.loadedTime = loadedTime || draftState.loadedTime;
		    draftState.nextCursor = nextCursor || null;
		    break;
		}
		case 'MORE_NEWSFEED': {
			draftState.loadingMore = true;
			break;
		}
		case 'MORE_NEWSFEED_$':{
			let { activities, hasMore, nextCursor, loadedTime } = action.json;
		    activities = dedupeByActionId(activities || []).map(activity => {
	      		return alignCommentActivity(activity)
	        })
			const existingKeys = new Set(draftState.activities.map(feedItemKey).filter(Boolean));
			const newActivities = activities.filter((a) => {
				const key = feedItemKey(a);
				return !key || !existingKeys.has(key);
			});
			draftState.activities = draftState.activities.concat(newActivities);
			draftState.hasMore = Boolean(hasMore);
			draftState.nextCursor = nextCursor || null;
			if (loadedTime) draftState.loadedTime = loadedTime;
			draftState.loadingMore = false;
			break;
		} 

		case "SET_DEMO":{
			draftState = action.demoNewsfeedJson;
		}
	}
	return draftState;
})

export default reducer;
